module.exports = __webpack_public_path__ + "img/prize.e5809b47.svg";